<template>
  <div>
    <h1 class="display-3">AK Wilno</h1>
    <p>
      Twórcą strony internetowej www.AKWilno.pl jest śp. Janusz Bohdanowicz, który znaczną część swojego życia poświęcił na gromadzenie materiałów
      o Armii Krajowej na Wileńszczyźnie, cyfryzacji zbiorów oraz ich upowszechnienie w postaci skanów fotografii, dokumentów i tekstów.
    </p>

    <b-row align-h="center">
      <b-col cols="12" xl="10" >
        <b-carousel class="carousel"
          style="text-shadow: 1px 1px 2px #333; margin: 0 0em 2em 0em;"
          controls
          indicators
          background="#ababab"
          :interval="4000"
        >
          <div v-for="carousel in carousels" :key="carousel.id">
            <b-carousel-slide
              :caption="carousel.title"
              :text="carousel.text"
              :img-src="carousel.img"
            ></b-carousel-slide>
          </div>
        </b-carousel>
      </b-col>
    </b-row>

    <p>
      Na stronie znajdują się cenne informacje, dotyczące żołnierzy Armii Krajowej na Wileńszczyźnie w okresie II wojny światowej -
      życiorysy dowódców oraz kalendaria działalności Brygad i Oddziałów Armii Krajowej, opracowania związane z operacją „Ostra Brama”,
      tworzeniem się struktur Podziemnego Państwa Polskiego na obszarze Wileńszczyzny. Strona powstała z myślą o badaczach dziejów Polski w XX wieku,
      pasjonatach historii czynów zbrojnych w XX wieku oraz dla tych wszystkich ludzi,
      którzy nadal poszukują informacji o swoich bliskich. Celem nadrzędnym, który postawił sobie śp. Janusz Bohdanowicz,
       była myśl o ocaleniu pamięci o żołnierzach Armii Krajowej dla przyszłych pokoleń Polaków.
    </p>

    <p>
      Ideę tę podtrzymuje Ośrodek KARTA, który od 2013 r. opiekuje się stroną internetową po śmierci p. Janusza Bohdanowicza.
    </p>
  </div>
</template>

<script>
import home from '@/models/home.js'

export default {
  name: 'home',
  methods:{
    elo: function(img){
      return img;
    }
  },
  data: function(){
    return{
      carousels: home.carousels
    }
  },
  metaInfo: {
    title: 'Strona główna',
    meta:[
      {name: 'robots', content: 'index,follow' },
      {name: 'description', content: 'AK Wilno - strona stworzona przez śp. Janusz Bohdanowicz, który znaczną część swojego życia poświęcił na gromadzenie materiałów o Armii Krajowej na Wileńszczyźnie.' },
      {name: 'og:url', content: 'http://akwilno.pl' },
      {name: 'og:title', content: 'Strona główna' },
      {name: 'og:image', content: '/main/menu_logo.png' },
      {name: 'og:description', content: 'AK Wilno - strona stworzona przez śp. Janusz Bohdanowicz, który znaczną część swojego życia poświęcił na gromadzenie materiałów o Armii Krajowej na Wileńszczyźnie.' },
      {name: 'twitter:url', content: 'http://akwilno.pl' },
      {name: 'twitter:title', content: 'AK Wilno' },
      {name: 'witter:image', content: '/main/menu_logo.png' },
      {name: 'twitter:description', content: 'AK Wilno - strona stworzona przez śp. Janusz Bohdanowicz, który znaczną część swojego życia poświęcił na gromadzenie materiałów o Armii Krajowej na Wileńszczyźnie.' }
    ]
  }
}
</script>



// WEBPACK FOOTER //
// src/components/home.vue